module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/flowers@3x_0a7508.jpg";